import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteStudentEnrollment({ open, onOpenChange, courseId, userId, studentName, onDeleted }) {
    const [loading, setLoading] = useState(false);
    const { getToken } = useAuth();

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            if (!token) return
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            await axios.delete(api_endpoint + `/course/enrollment/${courseId}/${userId}`, reqConfig)
            toast.success(`Student enrollment for "${studentName}" deleted successfully!`)
            onOpenChange(false);
            if (onDeleted) onDeleted(userId)
        } catch (error) {
            console.error("Error deleting student enrollment:", error)
            toast.error(`Failed to delete student enrollment for "${studentName}".`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {/* <span
                className="text-red  hover:underline cursor-pointer"
                onClick={() => setOpen(true)}
            >
                Delete Lesson
            </span> */}
            <Dialog open={open} onOpenChange={onOpenChange}>
                {/* <DialogTrigger asChild> */}
                    {/* <Button
                        variant="outline"
                        size="sm"
                        className="text-red border-red hover:bg-blue hover:border-transparent hover:text-white"
                        {...triggerButtonProps}
                    > */}
                        {/* <Edit className="w-4 h-4 mr-2" /> */}
                        {/* Delete Student Enrolled to this course
                    </Button>
                </DialogTrigger> */}
                <DialogContent className="max-w-md h-auto">
                    <DialogHeader>
                        <DialogTitle className="font-heading">Delete Student Enrollment</DialogTitle>
                       
                    </DialogHeader>
                    <div className="font-body">
                        Are you sure you want to delete the student enrolled in this course for <b>{studentName}</b> ? This action cannot be undone.
                    </div>
                    <DialogFooter className="">
                        <DialogClose asChild>
                            <Button
                                variant="outline"
                                onClick={() => onOpenChange(false)}
                                disabled={loading}
                                className="">
                                Cancel
                            </Button>
                        </DialogClose>
                        <Button
                            variant=""
                            onClick={handleDelete}
                            disabled={loading}
                            className=""
                        >
                            {loading ? (
                                <span className="flex items-center justify-center w-full">
                                    <ClipLoader size={20} color="#fff" />
                                </span>
                            ) : (
                                "Delete"
                            )}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}